module.exports = "https://cdn.landi.com/assets/peilian/offical_website_pc/1.0.41/images/b26dc7fc7cf06fcf2ce600f81dfda543.png";